import React, { useEffect, useState } from 'react';
import RoomDependentWrapperPage from '@common/components/Room/RoomSelectors/RoomDependentWrapperPage';
import CustomSnackbar from '@common/components/Feedback/CustomSnackbar';
import { useTranslation } from 'react-i18next';
import { selectFloorsRestSet } from 'store/local-robot/local-robot-slice-selectors';
import { useAppDispatch, useAppSelector } from 'store';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import getSaveErrorMessages from '@common/functions/general/get-save-error-messages';
import { patchFloorsRestSet } from 'store/local-robot/local-robot-slice';
import FloorConfigurationDialog from '@common/components/Room/Floors/FloorConfigurationDialog';
import FloorPlanner from '@common/components/Room/Floors/FloorPlanner';

const RoomOverviewPage: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const floorsRestSet = useAppSelector((state) => selectFloorsRestSet(state));

  const [isEditFloorOpen, setIsEditFloorOpen] = useState<string | null>(null);

  useEffect(() => {
    if (floorsRestSet.patchStatus === HttpFetchStatus.Success) {
      setIsEditFloorOpen(null);
    }
  }, [floorsRestSet.patchStatus]);

  const snackbarCloseHandler = () => {
    dispatch(patchFloorsRestSet({ patchError: null, patchStatus: HttpFetchStatus.Idle }));
  };

  const closeEditFloorHandler = () => {
    setIsEditFloorOpen(null);
  };

  const editFloorClickHandler = (selectedFloorId: string) => {
    setIsEditFloorOpen(selectedFloorId);
  };

  return (
    <React.Fragment>
      <RoomDependentWrapperPage
        showFloorSelect
        scrollable
        onEditFloorClickHandler={editFloorClickHandler}
      >
        <FloorPlanner />
      </RoomDependentWrapperPage>
      <FloorConfigurationDialog floorId={isEditFloorOpen} onClose={closeEditFloorHandler} />
      <CustomSnackbar
        title={t('success-saving-room')}
        open={floorsRestSet.patchStatus === HttpFetchStatus.Success}
        onClose={snackbarCloseHandler}
        severity="success"
      />
      <CustomSnackbar
        title={t('error-saving-room')}
        open={floorsRestSet.patchStatus === HttpFetchStatus.Failed}
        textMessages={getSaveErrorMessages(floorsRestSet.patchError)}
        onClose={snackbarCloseHandler}
        severity="error"
      />
    </React.Fragment>
  );
};

export default RoomOverviewPage;
